module.exports = __webpack_public_path__ + "media/images/trash_can_on-7f123583a90b5c8954d8f0e7360d0a93.png";